import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { validateRequired } from 'utils/form';
import './checkbox.styles.scss';
import { ValidationOptions } from 'react-hook-form/dist/types';
import { CustomCheckbox, CheckboxProps } from './CustomCheckbox';

interface CheckboxFieldProps extends CheckboxProps {
	validation?: ValidationOptions;
}

export const CustomCheckboxField: React.FC<CheckboxFieldProps> = ({
	validation = {},
	required,
	name,
	title,
	onChange,
	...props
}) => {
	const { register } = useFormContext();
	const { t } = useTranslation('errors');

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		if (onChange) {
			onChange(e);
		}
	}

	return (
		<CustomCheckbox
			name={name}
			title={title}
			onChange={handleChange}
			ref={register({
				...validateRequired(required, t('required')),
				...validation,
			})}
			{...props}
		/>
	);
};
